import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=3a29f8e7&scoped=true"
import script from "./page3.vue?vue&type=script&lang=js"
export * from "./page3.vue?vue&type=script&lang=js"
import style0 from "./page3.vue?vue&type=style&index=0&id=3a29f8e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a29f8e7",
  null
  
)

export default component.exports